import React from "react";

function TypeWritterLoader({status}) {
  return (
    <div className="flex-col-center">
      <div className="anim-container">
        <div className="typewriter">
          <div className={!status ? "slide" : "slide-stuck"}>
            <i></i>
          </div>
          <div className={!status ? "paper" : "paper-stuck"}></div>
          <div className={!status ? "keyboard" : "keyboard-stuck"}></div>
        </div>
        {status && (
          <div className="smoke">
            <span className="s0"></span>
            <span className="s1"></span>
            <span className="s2"></span>
            <span className="s3"></span>
            <span className="s4"></span>
            <span className="s5"></span>
            <span className="s6"></span>
            <span className="s7"></span>
            <span className="s8"></span>
            <span className="s9"></span>
          </div>
        )}
      </div>
      {!status && (
        <div
          style={{
            marginTop: "60px",
          }}
        >
          <h4 className="status-code-ok">Please wait..</h4>
          <p className="line-1 anim-typewriter">Document is on its way</p>
        </div>
      )}
      {status && (
        <div className="flex-col-center"
          style={{
            marginTop: "60px",
          }}
        >
          <h1>404</h1>
          <p className="line-1 anim-typewriter">
            Requested document is not available
          </p>
        </div>
      )}
    </div>
  );
}

export default TypeWritterLoader;
